const styleGuide = {
  spacing: 8,
  marginSpacing: 20,
  palette: {
    background: '#F3F4F6',
    backgroundPrimary: '#f6f6f6',
    backgroundGrey: '#EFF0F0',
    backgroundGreyHover: '#e8e8e8',
    primary: '#075453',
    primaryHover: '#064847',
    primary2: '#49AE9E',
    primary2Hover: '#3f9789',
    secondary: '#e39a9c',
    tertiary: '#333',
    // tertiary: "#6bacab",
    headerColor: '#2c6868',
    graphColor: '#ebd0d1',
    borderColor: '#f2f2f2',
    darkGreyColor: '#1e1e1e',
    greyColor: '#828282',
    lightGreyColor: '#d0d0d0',
    rippleColor: '#a3c5c5',
    ripplesecondColor: '#c5a3b9',
    rippleGreyColor: '#666',
    redColor: '#d25d60',
    donutColor: '#aaa',
    arrowColor: '#505054',
  },
};

export default styleGuide;
